export const combineSxProps = (...sxProps) => {
    return sxProps.filter(Boolean).flat(Infinity);
};
//# sourceMappingURL=combineSxProps.js.map